import type { FC, PropsWithChildren } from 'react';
import type { ResetTuneProps } from '@/components/deviceTunes/interfaces.ts';

import styled from 'styled-components';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';

import { ResetButtonWithConfirmation } from './ResetButtonWithConfirmation';

export const ResetTune: FC<PropsWithChildren<ResetTuneProps>> = (props: ResetTuneProps) => {
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <ControlContainer>
          <ResetHeader>{props.label}</ResetHeader>
          <ResetButtonWithConfirmation label={props.label} descriptors={props.descriptors} />
        </ControlContainer>
      </FormControl>
    </Box>
  );
};

const ControlContainer = styled.div`
  position: relative;
  margin: 0.6em 0.6em 0 0;
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const ResetHeader = styled.h3`
  margin: 0.5em 0 0.7em 0;
  font-size: 1.1em;
  font-weight: normal;
  color: ${({ theme }): string => theme.palette.secondary.light};
`;
